import { styled } from '../../config'
import { Box } from './Box'

export const OutlinedBox = styled(Box, {
  color: '#5263F4',
  fontSize: '12px',
  borderRadius: '4px',
  padding: '4px',
  border: '2px solid #5263F4',
  boxSizing: 'border-box',
  fontFamily: 'sans-serif'
})
